import { useContext, useEffect, useState } from "react";
import { AccountContext } from "../../providers/accountProvider";

function useSubCreationTab( history ) {
  const params = new URLSearchParams(window.location.search);
  const { user, isHindiUgcUser } = useContext(AccountContext)
  const [tabSelected, setTabSelected] = useState(null)

  const handleTabClick = (index) => {
    setTabSelected(index)
    if(index === 1){
      history.replace(`${window.location.pathname}?is_series=1`);
    }else{
      history.replace(`${window.location.pathname}?is_novel=1`);
    }
  }

  useEffect(() => {
    if(params.get("is_novel")){
      setTabSelected(0)
    }else if(isHindiUgcUser && (user?.source_app?.includes('pfm') || params.get('is_series'))){
      setTabSelected(1)
    }else{
      setTabSelected(0)
    }
  },[user])

  return {
    tabSelected,
    handleTabClick
  }
}

export default useSubCreationTab;